import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  state: {
    api: "/api/v2",
    chartData: {
      deviceCountByFormFactor: {
        data: [],
        loading: false,
        error: false,
        errorMessage: "",
        originalError: null,
        lastUpdatedAt: null,
      },
      deviceCountByModel: {
        data: [],
        loading: false,
        error: false,
        errorMessage: "",
        originalError: null,
        lastUpdatedAt: null,
      },
      deviceCountByWarrantyExpiration: {
        data: [],
        loading: false,
        error: false,
        errorMessage: "",
        originalError: null,
        lastUpdatedAt: null,
      },
      devicesByAge: {
        data: [],
        loading: false,
        error: false,
        errorMessage: "",
        originalError: null,
        lastUpdatedAt: null,
      },
      devicesByUtilisation: {
        data: [],
        loading: false,
        error: false,
        errorMessage: "",
        originalError: null,
        lastUpdatedAt: null,
      },
      deviceBuildNumber: {
        data: null,
        loading: false,
        error: false,
        errorMessage: "",
        originalError: null,
        lastUpdatedAt: null,
      },
      deviceOperatingSystem: {
        data: null,
        loading: false,
        error: false,
        errorMessage: "",
        originalError: null,
        lastUpdatedAt: null,
      },
      hourlyBandwidthUsage: {
        department: [],
        nonDepartment: [],
        loading: false,
        error: null,
        errorMessage: null,
        lastUpdatedAt: null,
      },
      numberOfHits: {
        data: [],
        loading: false,
        error: false,
        errorMessage: "",
        originalError: null,
        lastUpdatedAt: null,
      },
      bandwidthUsage: {
        data: [],
        loading: false,
        error: false,
        errorMessage: "",
        originalError: null,
        lastUpdatedAt: null,
      }
    },
    devices: {
      data: [],
      pagination: {
        totalItems: 0,
        page: 1,
        rowsPerPage: 10,
        sortBy: '',
        descending: false,
      },
      loading: false,
      error: false,
      errorMessage: "",
      originalError: null,
      lastUpdatedAt: null,
    },
    deviceCount: {
      data: null,
      loading: false,
      error: false,
      errorMessage: "",
      originalError: null,
      lastUpdatedAt: null,
    },
    filters: {
      formfactor: '',
      model: '',
      age: '',
      utilisation: '',
      warranty: '',
      buildNumber: '',
      operatingSystem: '',
    },
  },
  actions,
  getters,
  mutations,
}
